import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { search } from "actions/scooter/trip/actions";
import { Link } from "react-router-dom";
import moment from "moment";
import CommonTable from "../../../../lib/components/CommonTable";
import getFilesUrl from "../../../../../helpers/getFilesUrl";


const ScooterSingleHistory = (props) => {
  const {
    search,
    scooterId,
    actionList,
  } = props;
  useEffect(() => {
    search(0, 10, "end,desc", [{
      fieldName: "scooter",
      fieldValue: scooterId,
      searchOperation: "EQUALS"
    }]);
  }, [search, scooterId]);

  if (!Object.keys(actionList).length || !actionList.content) return null;

  const getColumns = () => [
    {
      id: "user",
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "scooter",
      Header: "Scooter",
      accessor: "scooter",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.scooter) {
          return (
            <Link to={`/scooter/scooter/${original.scooter}`}>
              {original.scooter}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "scan",
      Header: "Scan",
      Cell: ({ original }) => moment(original.scan)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "start",
      Header: "Start",
      Cell: ({ original }) => moment(original.start)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "end",
      Header: "End",
      Cell: ({ original }) => moment(original.end)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "startMileage",
      Header: "Start Mileage",
      Cell: ({ original }) => original.startMileage,
    },
    {
      id: "endMileage",
      Header: "End Mileage",
      Cell: ({ original }) => original.endMileage,
    },
    {
      id: "photo",
      Header: "Photo",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        original.photo ? (
          <a href={getFilesUrl(original.photo)} target="_blank" rel="noopener noreferrer">
            Photo
          </a>
        ) : "Image not exists"
      ),
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={{
        ...actionList,
        page_number: 0,
        page_size: 10,
        total_count: 10,
        total_pages: 1
      }}
      getListFunction={() => {
      }}
      FiltersComponent={null}
      searchHookProps={{
        size: 10,
        sort: "start,DESC"
      }}
    />
  );
};

ScooterSingleHistory.propTypes = {
  scooterId: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  actionList: state.scooterTrip.list,
});

const mapStateToDispatch = dispatch => ({
  search: bindActionCreators(search, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ScooterSingleHistory);



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/single/scooter-single-history.js